import { grey } from "@mui/material/colors";

export const headerCellStyle = { backgroundColor: grey[100], fontSize: 18 }

export const cellStyle = {
  fontSize: 18,
  verticalAlign: "top",
};

export const cellWidePaddingStyle = {
  ...cellStyle,
  py: 3
}

export const tableInRowStyle = {
  "& td" : {
    px: 0,
  },
  "&:last-child": {
    "& td" : {
      borderBottom: 0,
      pb: 0
    }
  },
  "&:first-child": {
    "& td" : {
      pt: 0
    }
  }
}